import { render } from "./FPluginSingle.vue?vue&type=template&id=d387c996&scoped=true"
import script from "./FPluginSingle.vue?vue&type=script&lang=js"
export * from "./FPluginSingle.vue?vue&type=script&lang=js"

import "./FPluginSingle.vue?vue&type=style&index=0&id=d387c996&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d387c996"]])

export default __exports__